import {useScrollToSection} from '@aboutyou/ui-components';

const SHOW_PRODUCT_DETAILS_REVIEWS_SECTION = 'showProductDetailsReviewsSection';

export const useProductReviewSectionScrollManager = () => {
  const {
    disableScrollToSection: disableShowReviewsSection,
    shouldScrollToSection,
    scrollToSection,
    ScrollToTarget,
  } = useScrollToSection(SHOW_PRODUCT_DETAILS_REVIEWS_SECTION);

  return {
    scrollToReviewsSection: scrollToSection,
    disableShowReviewsSection,
    shouldScrollToSection,
    ScrollToTarget,
  };
};
